const store = {
  state: {
    config: {
      general: {
        logo: '',
      },
      homepage: {
        title: '',
        text: '',
      },
      footer: {
        text: '',
      },
      homepageseo: {
        seo: {},
      },
      search: {
        filters: { ticketSalesByVanPlan: true },
        city: '',
        showFilterToggle: true,
      },
    },
  },
  setConfig(section, key, value) {
    this.state.config[section][key] = value;
  },
  getConfig(section, key) {
    return this.state.config[section][key];
  },
}

window.store = store

export default store
